/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CustomerSelection} from "./customerSelection.zod";
import {ExpedientEditableFields} from "./expedientEditableFields.zod";
import {ExpedientState} from "./expedientState.zod";
import {NoteDto} from "./noteDto.zod";
import {RepresentativeSelection} from "./representativeSelection.zod";

export const ExpedientDto = ExpedientEditableFields.and(
  zod.object({
    expedientId: zod.uuid(),
    number: zod.string().describe("Immutable generated YY.NNN number."),
    state: ExpedientState,
    responsibles: zod.array(zod.uuid()).min(1),
    customer: CustomerSelection,
    representative: zod.union([RepresentativeSelection, zod.null()]).optional(),
    notes: zod.array(NoteDto),
  }),
);

export type ExpedientDto = zod.input<typeof ExpedientDto>;
export type ExpedientDtoOutput = zod.output<typeof ExpedientDto>;
